"use client";

import React from "react";
import { ArrowRight, CircleCheck as CheckCircle2, PhoneCall } from 'lucide-react';
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function CallToAction() {
  const shouldReduceMotion = useReducedMotion();
  const benefits = ["Apoio técnico especializado e dimensionamento à medida", "Representante exclusivo da Spraying Systems Co. em Portugal", "Otimização comprovada de consumo e eficiência industrial"];
  return <section id="calltoaction" data-nav="light" className="relative overflow-hidden bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 20
      }} whileInView={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="relative overflow-hidden rounded-2xl bg-primary px-6 py-12 text-primary-foreground shadow-xl sm:px-12 md:py-16 lg:px-16">
          {/* Subtle background industrial accent pattern */}
          <div aria-hidden="true" className="pointer-events-none absolute -right-16 -top-16 h-72 w-72 rounded-full bg-secondary/20 blur-3xl" />
          <div aria-hidden="true" className="pointer-events-none absolute -bottom-16 -left-16 h-72 w-72 rounded-full bg-secondary/15 blur-3xl" />

          <div className="relative z-10 grid grid-cols-1 items-center gap-8 lg:grid-cols-12 lg:gap-12">
            <div className="lg:col-span-7">
              <span className="inline-flex items-center gap-2 rounded-full bg-primary-foreground/10 px-3.5 py-1 text-xs font-medium tracking-wide text-primary-foreground">
                <PhoneCall className="size-3.5" />
                Engenharia de Pulverização Industrial
              </span>

              <h2 className="mt-4 font-default text-2xl font-bold tracking-tight text-primary-foreground sm:text-3xl lg:text-4xl">
                Encontre a solução de pulverização ideal para o seu processo
              </h2>

              <p className="mt-3 text-base text-primary-foreground/85 sm:text-lg">
                Fale com a nossa equipa de engenheiros e obtenha apoio técnico dedicado
                para selecionar os bicos e sistemas adequados à sua linha de produção.
              </p>

              <ul className="mt-6 space-y-2.5">
                {benefits.map((benefit, index) => <li key={index} data-index={index} className="flex items-start gap-2.5 text-sm text-primary-foreground/90 sm:text-base">
                    <CheckCircle2 className="mt-0.5 size-5 shrink-0 text-secondary-foreground" />
                    <span>{benefit}</span>
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-center lg:col-span-5 lg:flex-col lg:items-end lg:justify-center">
              <Button asChild size="lg" className="w-full bg-secondary px-8 py-6 text-base font-semibold text-secondary-foreground shadow-md transition-colors hover:bg-secondary/90 sm:w-auto">
                <Link to="/ContactsPage" className="inline-flex items-center justify-center gap-2">
                  Solicite um orçamento
                  <ArrowRight className="size-5" />
                </Link>
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}